import {
    useIO,
    useModel
} from "@type-r/react";
import { EmbeddedConfig, getEmbeddedConfig } from "../api/embeddedConfig";
import { Loading } from "lqx-react";
import React, { useState } from "react";
import { PowerBIEmbed } from 'powerbi-client-react';
import { models, Report, Embed } from 'powerbi-client';
import './reportView.css';

export const ReportView = ({ reportId }) => {


    // PowerBI Report object (to be received via callback)
    const [report, setReport] = useState<Report>();

    const [sampleReportConfig, setReportConfig] = useState<models.IReportEmbedConfiguration>({
        type: 'report',
        embedUrl: undefined,
        tokenType: models.TokenType.Embed,
        accessToken: undefined,
        settings: undefined,
    });
      var embedConfig = useModel(EmbeddedConfig);

    const isReady = useIO(async () => {

        var embedConfig1 = await getEmbeddedConfig(reportId, 'INB');
        console.log('embedConfig', embedConfig1);
        console.log('embedConfig1', embedConfig1.embedURL);
        setReportConfig({
            ...sampleReportConfig,
            embedUrl: embedConfig1.embedURL,
            accessToken: embedConfig1.token
        });
        // console.
        
    });
    //   if(isReady) {
    //     setReportConfig({
    // 		...sampleReportConfig,
    // 		embedUrl: embedConfig.embedURL,
    // 		accessToken: embedConfig.token
    // 	});
    //     console.log('Inside SET', embedConfig.embedURL, embedConfig.token);
    //   }
    return isReady ? (
        // <PageContainer>
        // <ReportContainer>
        <PowerBIEmbed
            embedConfig={sampleReportConfig}
            //	eventHandlers = { eventHandlersMap }
            	cssClassName = { "report-style-class" }
            getEmbeddedComponent={(embedObject: Embed) => {
                console.log(`Embedded object of type "${embedObject.embedtype}" received`);
                setReport(embedObject as Report);
            }}
        />
// </ReportContainer>
        /* </PageContainer> */
    ) : (
        <Loading />
    );



}

// const ReportContainer = div({
//     display: 'flex',
//     flexDirection: 'column',
//     flexGrow: 1
// })
